<template>
  <div ref="root" class="rounded-lg bg-[#D7E3FC] p-32">
    <WarrantyTag class="mb-32" />

    <p class="body-2-bold mb-12 text-center">
      {{ i18n(translations.free) }}
    </p>
    <h2 class="punchline mb-32 text-center">
      {{ i18n(translations.title) }}
    </h2>

    <div class="flex flex-col gap-16 md:flex-row">
      <div class="flex w-full flex-col gap-12 md:w-1/3">
        <div class="flex gap-8">
          <IconRepairMailIn />
          <span class="body-1-bold">{{ i18n(translations.item1title) }}</span>
        </div>
        <p class="body-2">{{ i18n(translations.item1description) }}</p>
      </div>

      <RevDivider
        class="border-static-info-mid hidden min-h-[100px] md:block"
        variant="vertical"
      />
      <RevDivider class="border-static-info-mid block md:hidden" />

      <div class="flex w-full flex-col gap-12 md:w-1/3">
        <div class="flex gap-8">
          <IconSmartphone />
          <span class="body-1-bold">{{ i18n(translations.item2title) }}</span>
        </div>
        <p class="body-2">{{ i18n(translations.item2description) }}</p>
      </div>

      <RevDivider
        class="border-static-info-mid hidden min-h-[100px] md:block"
        variant="vertical"
      />
      <RevDivider class="border-static-info-mid block md:hidden" />

      <div class="flex w-full flex-col gap-12 md:w-1/3">
        <div class="flex gap-8">
          <IconClock />
          <span class="body-1-bold">{{ i18n(translations.item3title) }}</span>
        </div>
        <p class="body-2">{{ i18n(translations.item3description) }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onUnmounted, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevDivider } from '@ds/components/Divider'
import { IconClock } from '@ds/icons/IconClock'
import { IconRepairMailIn } from '@ds/icons/IconRepairMailIn'
import { IconSmartphone } from '@ds/icons/IconSmartphone'
import { useIntersectionObserver } from '@vueuse/core'

import WarrantyTag from '../WarrantyTag/WarrantyTag.vue'

import translations from './ReassuranceWarranty.translations'

const i18n = useI18n()

const { trackProductBlockImpression } = useTracking()
const root = ref<HTMLElement | null>()

const { stop } = useIntersectionObserver(root, ([{ isIntersecting }]) => {
  if (isIntersecting) {
    trackProductBlockImpression({
      block_name: 'reassurance_warranty_block',
    })
  }
})

onUnmounted(() => {
  stop()
})
</script>
